import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material';
import { capitalize } from '@mui/material/utils';
import { IconButton } from '@mui/material';

import { ButtonAnimate } from '../../components/Animate';

const useStyles: any = makeStyles((theme: any) => {
  const createStyle = color => {
    return {
      color: theme.palette[color].main,
      '&:hover': {
        backgroundColor: alpha(
          theme.palette[color].main,
          theme.palette.action.hoverOpacity
        )
      }
    };
  };

  return {
    colorInfo: createStyle('info'),
    colorSuccess: createStyle('success'),
    colorWarning: createStyle('warning'),
    colorError: createStyle('error'),
    colorWhite: {
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.common.white,
          theme.palette.action.hoverOpacity
        )
      }
    }
  };
});

type Props = {
  children: React.ReactNode;
  className: string;
  color?:
    | 'default'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'white';
};

const MIconButton = forwardRef<any, any>(
  ({ color = 'default', children, className, ...other }: Props, ref) => {
    const classes = useStyles();

    if (
      color === 'default' ||
      color === 'inherit' ||
      color === 'primary' ||
      color === 'secondary'
    ) {
      return (
        <ButtonAnimate>
          <IconButton
            ref={ref}
            color={color}
            className={className}
            {...other}
            size="large"
          >
            {children}
          </IconButton>
        </ButtonAnimate>
      );
    }

    return (
      <ButtonAnimate>
        <IconButton
          ref={ref}
          className={clsx(classes[`color${capitalize(color)}`], className)}
          {...other}
          size="large"
        >
          {children}
        </IconButton>
      </ButtonAnimate>
    );
  }
);

export default MIconButton;
